<template>
  <div id="bottomLeft">
    <div class="bg-color-black">
      <div class="d-flex title-box">
        <!-- <span>
          <icon name="chart-bar" class="text-icon"></icon>
        </span> -->
        <div class="d-flex">
          <span class="fs-xl text_title mx-2 commonTitle">近一年洗涤量趋势</span>
        </div>
      </div>
      <div class="body-box">
        <WashingVolumeChart :data="result" v-if="show" />
      </div>
    </div>
  </div>
</template>

<script>
// import BottomLeftChart from '@/components/echart/bottom/bottomLeftChart'
import WashingVolumeChart from '@/components/echart/bottom/washingVolumeChart2'
import * as api from '@/api/index'

export default {
  components: {
    // BottomLeftChart
    WashingVolumeChart
  },
  data() {
    return {
      params: {
        // pageNum: 1,
        // pageSize: 10,
        // startTime: '',
        // endTime: '',
        customerId: ''
      },
      result: [],
      show: false,
      intervalId: null // 鐢ㄤ簬瀛樺偍瀹氭椂鍣ㄧ殑 ID
    }
  },
  mounted() {
    this.params.customerId = this.$route.query.customerId

    this.getData()

    // refresh every 30 minutes
    this.intervalId = setInterval(() => {
      this.getData()
    }, 30 * 60 * 1000)
  },
  beforeDestroy() {
    // clear timer before destroy
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  methods: {
    fillMissingMonths(data) {
      const filteredData = data.filter((item) => item.month !== null && item.month !== undefined)

      const allMonths = Array.from({ length: 12 }, (_, i) =>
        (i + 1).toString().padStart(2, '0')
      )
      const existingMonths = filteredData.map((item) => item.month)
      const missingMonths = allMonths.filter((month) => !existingMonths.includes(month))

      missingMonths.forEach((month) => {
        filteredData.push({
          month,
          num: 0,
          remark: null,
          type: []
        })
      })

      filteredData.sort((a, b) => parseInt(a.month) - parseInt(b.month))

      return filteredData
    },

    async getData() {
      this.params.statusApprove = 0
      const res = await api.getNewBigSkuWashMonth(this.params)
      // console.log('杩戜竴骞存礂娑よ秼鍔?----------',res, this.params)
      if (res.ResultCode != 0) return
      this.$nextTick(() => {
        this.result = res.Result || []
        console.log('娲楁钉閲忔暟鎹?', this.result)
        
        // 鐩存帴浣跨敤杩斿洖鐨勬暟鎹紝涓嶉渶瑕侀澶栫殑鎺ュ彛璋冪敤
        setTimeout(() => {
          this.show = true
        }, 100); // 鍑忓皯寤惰繜鏃堕棿
      })
    },
    getCurrentDate(dateString) {
      var month = dateString.padStart(2, '0'); // 纭繚鏈堜唤鏄袱浣嶆暟
      var year;
      let currMonth = new Date().getMonth()+1;
      if(currMonth >= parseInt(month) ){
        year = new Date().getFullYear(); // 鑾峰彇褰撳墠骞翠唤
      }else{
        year = new Date().getFullYear() - 1 // 鍘诲勾
      }
      
      var day;

      // 2鏈堜唤鐗规畩澶勭悊
      if (month === '02') {
        day = this.isLeapYear(year) ? '29' : '28';
      } else {
        // 鍏朵粬鏈堜唤鏍规嵁鏄惁涓洪棸骞存潵纭畾澶╂暟
        day = [31, this.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][parseInt(month) - 1];
      }

      return [`${year}-${month}-01`, `${year}-${month}-${day}`];
    },
    isLeapYear(year) {
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    },
    async getBigSkuWashCategoryTime(item) {
      const params = {
        customerId: this.$route.query.customerId,
        startTime: item[0],
        endTime: item[1]
      }
      params.statusApprove = 0
      const res = await api.getBigSkuWashCategoryTime(params)
      if (res.ResultCode != 0) return
      return res.Result
    }
  }
}
</script>

<style lang="scss" scoped>
//$box-height: 320px;
//$box-width: 100%;

#bottomLeft {
  //padding: 20px 16px;
  // height: $box-height;
  width: 100%;
  height: 100%;
  border-radius: 5px;

  .bg-color-black {
    height: 100%;
    border-radius: 10px;
    .title-box{
      height: 15%;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
    .body-box{
      height: 85%;
      overflow: hidden;
    }
  }

  .chart-box {
    margin-top: 16px;
    width: 170px;
    height: 170px;

    .active-ring-name {
      padding-top: 10px;
    }
  }
}
</style>

